/**
 * @param {vueInstance} context - This
 * @returns {Section}
 */
export default function (context) {
  const { id } = context.item

  return {
    key: 'buyer_heading',
    resource: '',
    type: 'Section',
    title: {
      id: 'buyers_title',
      label: context.$t('bid'),
      icon: '',
      style: '',
    },
    border: true,
    actions: [
      {
        id: 'buyers_title',
        label: `${context.$t('showAll')} ${context.$t('bid').toLowerCase()}`,
        icon: ['fal', 'arrow-to-right'],
        type: 'button',
        tag: 'router-link',
        theme: 'primary',
        to: {
          name: `${context.type}-residentials`,
          params: { id },
          query: { 'filter.status': 'sold' },
        },
      },
    ],
  }
}
